import controller from './officeDelivery.controller';
import template from './officeDelivery.html';

const OfficeDeliveryDetailsComponent = {
  restrict: 'E',
  bindings: {},
  template,
  controller
};

export default OfficeDeliveryDetailsComponent;



/** WEBPACK FOOTER **
 ** ./client/app/components/services/officeDelivery/officeDelivery.component.js
 **/